import cloneDeep from 'lodash/cloneDeep';
import { ColorStyleMethodEnum, findChartColorPaletteById, getMonochromaticPaletteVariations } from '../../chart-models/chart-presets/colors';
import { TDColor } from '../color/td-color';
import { IThemeModel } from '../../Interface/theme-model.interface';

export function getThemeColorValueByIndex(
    index: number,
    colorPaletteId: string,
    total: number,
) {
    const colorPalette = findChartColorPaletteById(colorPaletteId);
    const { schemeClrs, variations, meth } = colorPalette;
    // 有variations （循环变换色盘）
    if (schemeClrs && variations) {
        const remainder = index % schemeClrs.length;
        const quotient = Math.floor(index / schemeClrs.length);
        const schemeClrVal = schemeClrs[remainder];
        const egColorChoice = variations[quotient % variations.length];
        const color = new TDColor({
            themeKey: schemeClrVal,
            lumMod: egColorChoice?.lumMod,
            lumOff: egColorChoice?.lumOff,
            shade: egColorChoice?.shade,
            tint: egColorChoice?.tint,
        });
        return color;
    }
    // 线性变换色盘
    if (schemeClrs && total) {
        const variations = getMonochromaticPaletteVariations(total);
        const variation = meth === ColorStyleMethodEnum.withinLinearReversed
            ? variations.reverse()[index] : variations[index];
        const color = new TDColor({
            themeKey: schemeClrs[0],
            shade: variation?.shade,
            tint: variation?.tint,
            lumMod: variation?.lumMod,
            lumOff: variation?.lumOff,
        });
        return color;
    }
}

export function getFirstThemeLineStyle(themeModel: IThemeModel) {
    const [lnStyleLst] = themeModel?.fmtScheme?.lnStyleLst?.ln || [{}];
    const firstLineStyle = cloneDeep(lnStyleLst[0]);
    return firstLineStyle;
}

export function getThemeStyleTransformOpt(styleVal) {
    // 130是取accent4，border的7倍
    // 104相对是普通的，按索引取accent，border的3倍
    // 102是色板的一个系列，其中颜色暂时未逆向出规则
    const styleValMap: Record<number, { borderScale: number; accentStartIndex: number; }> = {
        104: {
            borderScale: 3,
            accentStartIndex: 0,
        },
        130: {
            borderScale: 7,
            accentStartIndex: 3,
        },
    };

    const { borderScale, accentStartIndex } = styleValMap[styleVal || 104] || styleValMap[104];
    return { borderScale, accentStartIndex };
}
